import React from 'react';

import Routes from './Routes';
import Menu from './Menu';
import { AuthorizeModal } from './authorizeOrder';
import { CaptureModal } from './captureOrder';
import { RefundModal } from './refundOrder';
import { CancelModal } from './cancelOrder';

import effects from './effects';
import { EnvFrame } from '../auth/accessToken';
import * as reducer from './reducer';

const Orders = () => (
    <>
        <EnvFrame>
            <Menu />
            <Routes />
            <AuthorizeModal />
            <CaptureModal />
            <RefundModal />
            <CancelModal />
        </EnvFrame>
    </>
);

export { Orders, effects, reducer };
